// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QGAeu","input":"styles_input__2S6mQ"};